import { MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

import { CONTEXT_MENU_DESIGN, getContextMenuItemSx } from '../contextMenuDesign';

export const ContextMenuItem = styled(MenuItem)(({ theme }) => ({
  ...getContextMenuItemSx(theme),

  '& > svg:last-child': {
    marginLeft: 'auto',
    width: CONTEXT_MENU_DESIGN.iconSize,
    height: CONTEXT_MENU_DESIGN.iconSize,
  },
}));
